import { render, staticRenderFns } from "./dataOutputAssociation.vue?vue&type=template&id=ec57134e&"
import script from "./dataOutputAssociation.vue?vue&type=script&lang=js&"
export * from "./dataOutputAssociation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports